<template>
    <div class="menu-cart">
        <ul class="products-list product-list-in-card pl-2 pr-2">
            <li class="item" v-for="(item, index) in orderList" :key="index">
                
                <div class="product-img">
                    <img :src="item.imageDetail" alt="Product Image" class="img-size-50">
                </div>
                <div class="product-info">
                    <a href="javascript:void(0)" class="product-title">
                        {{ item.productName }}
                    </a>
                    <span class="product-description">
                        {{ $t('cart.quantity') }}: {{ item.quantity }}
                    </span>
                    <span class="product-description">
                        <!-- {{ $t('cart.price') }}: {{ Utils.parseMoney(item.totalPrice + '') }} {{ item.currency || 'USD' }} -->
                        {{ $t('cart.price') }}: <MoneyView :curency="item.currency" :money="item.totalPrice"> </MoneyView>

                        
                    </span>
                </div>
            </li>
            <li class="item">
                <div class="bottom-cart">
                    <span class="bold">{{ $t('cart.quantity') }}: {{ quantity }}</span>
                    <span class="bold">{{ $t('cart.total') }}:  <MoneyView :money="totalMoney"> </MoneyView></span>
                </div>
            </li>
            <li class="item">
                <div class="bottom-cart">
                    <div @click="viewCart" class="btn-cart-order cart-view">{{ $t('cart.viewCart') }}</div>
                    <div @click="payCart" class="btn-cart-order cart-pay">{{ $t('cart.checkout') }}</div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script setup lang="ts">
import store from "@/store";
import cardUtils from '@/utils/CardUtils';

import Utils from "@/utils/Utils";
import { ref, onMounted, watch, computed, createVNode } from "vue";
import { useRoute, useRouter } from "vue-router";
import MoneyView from '@/components/money/text/MoneyView.vue'
const router = useRouter();
const orderList = ref([]);
const quantity = ref(0);
const money = ref(0);
const moneyShip = ref(0);
const totalMoney = ref(0);
onMounted(async () => {
    await loadCart();
});
const loadCart = () => {

    const dataList = cardUtils.getLcCart() || [];
    // reset trước khi tính
    totalMoney.value = 0;
    quantity.value = 0;

    for (let i = 0; i < dataList.length; i++) {

        const item = dataList[i];
        const price = item.minPrice ?? 0;
        const qty = item.quantity ?? 0;
        const itemTotal = qty > 0 ? price * qty : 0;
        totalMoney.value += itemTotal;
        quantity.value += qty;
        dataList[i].totalPrice = itemTotal; 
    }

    orderList.value = dataList;
};
const viewCart = () => {
    router.push({ path: "/cart" });
};
const payCart = () => {
    router.push({ path: "/payment" });
};
const isLoadCart = computed(() => {
    return store.getters.isLoadCart;
});
watch(isLoadCart, async (newValue, oldValue) => {
    await loadCart();
});
</script>
<style lang="css" scoped>
.menu-cart {
    background-color: rgba(16, 37, 66, 0.75);
    min-width: 350px;
    min-height: 200px;
}

.products-list {
    margin-top: 20px;
    padding-top: 20px;
}

.products-list>.item {
    border-radius: 0.25rem;
    background-color: unset;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: left;
}

.product-info a {
    color: #fff;
    text-decoration: none;
}

.product-info span {
    color: #aaa;
}

.products-list .product-info {
    margin-left: 20px;
}

.bottom-cart {
    min-height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #aaa;
}

.product-list-in-card>.item {
    border-bottom: 1px solid #aaa;
}

.products-list>.item {
    border-radius: unset;
}
</style>